import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=6355ec2f"
import script from "./UploadInput.vue?vue&type=script&lang=js"
export * from "./UploadInput.vue?vue&type=script&lang=js"
import style0 from "./UploadInput.vue?vue&type=style&index=0&id=6355ec2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports